import { App } from '../report/App';
import { ErrorBoundary, NotFound, Privacy } from './Shell';

export type Route = 'home' | 'privacy' | 'notfound';

export function route(path: string): Route {
  const p = path.replace(/\/+$/, '') || '/';
  return p === '/' || p === '/index.html' ? 'home' : p === '/zasebnost' ? 'privacy' : 'notfound';
}

/** Path routing for the few static pages; everything else is the app at "/" (reports are "/?ko=…&p=…"). */
export function Page({ path }: { path: string }) {
  const r = route(path);
  return <ErrorBoundary>{r === 'home' ? <App /> : r === 'privacy' ? <Privacy /> : <NotFound />}</ErrorBoundary>;
}
